'use strict';

var SnapshotDatesChartViewport = function SnapshotDatesChartViewport(ChartViewport, chartGroups, chartXAxis, chartSimpleBars, chartParams, chartScales, mapService) {
  var Chart = function Chart(container, formatters) {
    var groups = chartGroups(mapService.getMapComponent('group')).asViewport();
    var m1Bars = chartSimpleBars(mapService.getMapComponent('m1Bar'));
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withRepetition(1).withoutLine();
    ChartViewport.call(this, container, chartParams, chartScales, groups, m1Bars, xAxis);
    this.changeMetrics = function () {
      groups.withPropertyName(mapService.getMapComponent('group'));
      m1Bars.withYPropertyName(mapService.getMapComponent('m1Bar'));
      return this;
    };
  };
  Chart.prototype = Object.create(ChartViewport.prototype);
  Chart.constructor = Chart;
  return Chart;
};
SnapshotDatesChartViewport.$inject = ['ChartViewport', 'ChartElementsGroup', 'ChartElementsXAxis', 'ChartElementsSimpleBars', 'SnapshotDatesViewportParams', 'SnapshotDatesViewportScales', 'SnapshotDatesMapDataToChartComponentsService'];
module.exports = SnapshotDatesChartViewport;